/** Shared CTA buttons. PrimaryButton = canonical gold gradient; SecondaryButton = gold ghost/outline. */
import type { ButtonHTMLAttributes } from 'react';
import styles from './Button.module.css';

type Props = ButtonHTMLAttributes<HTMLButtonElement>;

export function PrimaryButton({ className = '', type = 'button', ...rest }: Props): JSX.Element {
  return <button type={type} className={`${styles.primary} ${className}`.trim()} {...rest} />;
}

export function SecondaryButton({ className = '', type = 'button', ...rest }: Props): JSX.Element {
  return <button type={type} className={`${styles.secondary} ${className}`.trim()} {...rest} />;
}
